export default function DOM_Element() {
  return (
    <div>
      <h1>DOM_Element</h1>
      <p>This is the DOM_Element component.</p>
    </div>
  );
}